import { EventApiModel } from '../event/event.api.model';

export class ReservationEventApiModel extends EventApiModel {}
